module.exports = __webpack_public_path__ + "flaticon.7884e37efb3695f4ebd7";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/multi-sports/flaticon.ttf
// module id = ../../../../../src/scss/multi-sports/flaticon.ttf
// module chunks = styles